export default "__VITE_ASSET__cba24fdf__"